import { Button, Tooltip } from 'antd';
import { AudioOutlined, FileImageOutlined, TableOutlined, FormOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var embedsItems = function embedsItems(labels) {
  return [{
    type: 'button',
    key: 'table',
    tooltip: labels.table,
    icon: /*#__PURE__*/_jsx(TableOutlined, {}),
    onClick: function onClick(_ref) {
      var editor = _ref.editor;
      return editor.chain().focus().insertTable({
        rows: 3,
        cols: 3,
        withHeaderRow: true
      }).run();
    }
  }, {
    type: 'button',
    key: 'image',
    tooltip: labels.addImage,
    icon: /*#__PURE__*/_jsx(FileImageOutlined, {}),
    onClick: function onClick(_ref2) {
      var addImage = _ref2.addImage;
      return addImage();
    }
  }, {
    type: 'button',
    key: 'audio',
    tooltip: labels.addAudio,
    icon: /*#__PURE__*/_jsx(AudioOutlined, {}),
    onClick: function onClick(_ref3) {
      var addAudio = _ref3.addAudio;
      return addAudio();
    }
  }, {
    type: 'button',
    key: 'math',
    tooltip: labels.addMath || 'Add Math',
    icon: /*#__PURE__*/_jsx(FormOutlined, {}),
    onClick: function onClick(_ref4) {
      var editor = _ref4.editor;
      return editor.chain().focus().insertMath().run();
    }
  }];
};

export var EmbedsMenu = function EmbedsMenu(_ref5) {
  var editor = _ref5.editor,
      addImage = _ref5.addImage,
      addAudio = _ref5.addAudio,
      labels = _ref5.labels,
      hideMath = _ref5.hideMath;
  var items = embedsItems(labels);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map(function (item, index) {
      if (item.key === 'image' && !addImage) return null;
      if (item.key === 'audio' && !addAudio) return null;
      if (item.key === 'math' && hideMath) return null;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: item.tooltip,
        children: /*#__PURE__*/_jsx(Button, {
          icon: item.icon,
          onClick: function onClick() {
            return item.onClick({
              editor: editor,
              addImage: addImage,
              addAudio: addAudio
            });
          },
          type: "text"
        })
      }, index);
    })
  });
};